<template>
<li class="crop-group__item" :class="cropGroupItem.class">
  <div class="crop-group__image">
    <img class="crop-group__image-pic" alt="crop-group" :src="cropGroupItem.pic">
  </div>

  <div class="crop-group__info">
    <h3 class="crop-group__title">{{ cropGroupItem.title }}</h3>
    <div class="crop-group__text">
      <span>{{ cropGroupItem.text }}</span>
      <ul class="crop-group__kind" v-if="cropGroupItem.kindsShow">
        <li class="crop-group__kind-item" v-for="cropKindItem in cropGroupItem.cropKinds"
         :key="cropKindItem" :cropKindItem="cropKindItem" v-html="cropKindItem.text">
        </li>
      </ul>
    </div>
  </div>
</li>
</template>

<script>
export default {
  props: {
    cropGroupItem: {
      type: Object,
      default() {
        return {};
      },
    },
    cropKindItem: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$light-gray: #EEEEEE;
$blue: #4DB6BC;
$purple: #8293E8;

.crop-group {
  &__item {
    position: relative;
    background: #2B3138;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    border-radius: 40px;
    transition: 0.5s;
    padding: 20px;
    display: flex;
    align-items: center;

    @media (max-width: 1090px) {
      flex-direction: column;
      padding: 20px 20px 40px;
    }

    &.item-1 {
      grid-area: a;
    }

    &.item-2 {
      grid-area: b;
    }

    &.item-3 {
      grid-area: c;

      .crop-group__info {
        width: 80%;

        @media (max-width: 1090px) {
          width: 100%;
        }
      }
    }

    &.item-4 {
      grid-area: d;
    }

    &.item-5 {
      grid-area: e;
    }

    &.item-6 {
      grid-area: f;

      .crop-group__info {
        width: 72%;

        @media (max-width: 1090px) {
          width: 100%;
        }
      }
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 57%;

    @media (max-width: 1090px) {
      width: 100%;
      text-align: center;
    }
  }

  &__image {
    width: 240px;
    height: 220px;
    margin: 0 30px 0 -40px;

    @media (max-width: 1220px) {
      width: 180px;
      height: 160px;
    }

    @media (max-width: 1090px) {
      margin: -80px 0 30px 0;
    }

    @media (max-width: 780px) {
      width: 140px;
      height: 130px;
    }

    &-pic {
      border-radius: 20px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    }
  }

  &__title {
    color: $blue;
    font-family: 'montserratbold', sans-serif;
    font-size: 24px;
    line-height: 32px;
    margin: 0 0 22px;

    @media (max-width: 1130px) {
      font-size: 20px;
      line-height: 28px;
      margin: 0 0 15px;
    }
  }

  &__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #D5D6D7;
  }

  &__kind {
    display: flex;
    flex-direction: column;

    @media (max-width: 1090px) {
      align-items: center;
    }

    &-item {
      margin: 12px 0 0 25px;
      position: relative;

      &:before {
        content: ".";
        display: block;
        position: absolute;
        left: -10px;
        top: -3px;
        width: 5px;
        height: 5px;
        color: #D5D6D7;
      }
    }
  }
}
</style>
